import MyPhotosImport from './album-import/my-photos-import';
import CloudImport from './cloud-import';
import LocalFileImport from './local-file-import';
import LocalFileImportIndexedDB from './local-file-import-indexeddb';
import CombinedLoader from './combined-device-loader.jsx';
import CombinedLoaderIndexedDB from './combined-device-loader-indexed.jsx';
import { useGenStore } from 'stores/useGenStore';

const computeSources = (isSafariPrivate) => {
  const qrUploaderEnabled = !!window.qrLinkedMobileUploader?.enabled;
  let deviceService = LocalFileImport;
  if (window.prismItem) {
    if (window.featureFlags.indexed_db_uploader && !isSafariPrivate) {
      if (qrUploaderEnabled) {
        deviceService = CombinedLoaderIndexedDB;
      } else {
        deviceService = LocalFileImportIndexedDB;
      }
    }
  } else if (qrUploaderEnabled) {
    deviceService = CombinedLoader;
  }
  return [
    {
      title: 'My Devices',
      component: deviceService,
      service: 'upload',
    },
    {
      title: 'My Photos',
      component: MyPhotosImport,
      service: 'albums',
    },
    {
      title: 'Google',
      component: CloudImport,
      service: 'picasa',
    },
    {
      title: 'Facebook',
      component: CloudImport,
      service: 'facebook',
    },
    {
      title: 'Instagram',
      component: CloudImport,
      service: 'instagram',
    },
  ];
};

const getImageSources = () => {
  const isSafariPrivate = useGenStore.getState().isSafariPrivate;

  const imageSources = computeSources(isSafariPrivate);

  return imageSources;
};

export default getImageSources;
